export const getId = obj => obj?.id || obj?._id || obj;

export const handleImage = image => {
	if (typeof image == "string" && image) {
		if (image?.indexOf("http") < 0)
			image = `${process.env.REACT_APP_MAIN_URL}${image}`;
		else image = image?.replace("https", "http");
	}
	return image || "";
};
